import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import PageTitle from '~/components/PageTitle';
import ExportButton from '~/components/Button/ExportButton';
import Boat from './Boat';
import ForeBoat from './ForeBoat';

const App = () => {
  const dispatch = useDispatch();
  const WindsBoatList = useSelector(state => state.data.WindsBoatList || []);
  useEffect(() => { Actions_Wind.Gis.getWindsBoatList(dispatch); }, []);

  const onExport = () => {
    if (WindsBoatList.length === 0) {
      alert('無匯出資料');
    } else {
      excel.outputAryAry({
        data: WindsBoatList.map((o = {}) => ([
          o.job,
          o.ship_name,
          o.windfield_simplename,
          o.license_period_list.join('\n'),
          o.scheduled_period_list.join('\n'),
          // o.ording_issue,
          o.actural_taiwan_date,
          o.arrive_in_tw,
        ])),
        header: [
          '工作種類',
          '船名',
          '使用風場',
          '船舶許可期間',
          '預定使用期間',
          // '是否有風場先後承接問題',
          '實際抵台時間',
          '是否抵台',
        ],
        fileName: '多風場船舶_船舶資訊',
        wrapText: true,
      });
    }
  };

  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}
    >
      <PageTitle text='多風場船舶' />

      <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
      </div>
      <Boat />

      <ForeBoat />

    </div>
  );
};

export default App;
